import { useIntl } from 'react-intl';

import { useAppSelector } from 'hooks';
import { TABLE_EMPTY_VALUE, TABLE_MAX_AVATARS_DISPLAY } from 'constants/constants';
import AvatarNameColor from 'components/UI/AvatarNameColor';
import { getAllAdmins } from 'store/groups/reducer';

const UsersColumnView = ({ admins, row }: { admins: string[]; row: any }) => {
  const { formatMessage } = useIntl();
  const groupAdmins = useAppSelector(getAllAdmins);
  const displayNames = groupAdmins.reduce(
    (acc, admin) => {
      acc[admin.aid] = admin.name;
      return acc;
    },
    {} as Record<string, string>
  );

  if (!admins.length) return <>{TABLE_EMPTY_VALUE}</>;

  return (
    <>
      {admins.slice(0, TABLE_MAX_AVATARS_DISPLAY + 1).map((aid: string, index: number) => {
        const admin = groupAdmins.find((user) => user.aid === aid);
        const name = admin?.name
          ? admin?.name
          : (displayNames[aid] ? displayNames[aid] : '') +
            ' (' +
            formatMessage({ id: 'removedKey' }) +
            ')';

        if (index < TABLE_MAX_AVATARS_DISPLAY) {
          return (
            <AvatarNameColor
              key={index}
              size={25}
              className={
                index < Math.min(admins.length - 1, TABLE_MAX_AVATARS_DISPLAY) ? 'me-2' : ''
              }
              name={name}
              overlay
              dataTestId={`patient-assignee-${aid}`}
            />
          );
        } else {
          return <span key={index}>...</span>;
        }
      })}
    </>
  );
};

export default UsersColumnView;
